"use client";

import React from "react";
import { Database, CreditCard, Vote, Users, Activity, Cpu, ArrowDown, ShieldCheck, Stethoscope } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const accordionData = [{
  id: "data-access",
  title: "Access Key",
  icon: Database,
  content: "Securely access anonymized, real-world patient data for research and AI model training. Aizalea tokens act as the cryptographic key to unlock these premium datasets while ensuring strict patient privacy and regulatory compliance."
}, {
  id: "service-payment",
  title: "Ecosystem Engine\n",
  icon: CreditCard,
  content: "Utilize Aizalea for seamless, borderless payments across our physical network of medical centers and digital health platforms. Token users enjoy reduced transaction fees and priority access to advanced AI healthcare solutions."
}, {
  id: "network-governance",
  title: "Value Network",
  icon: Vote,
  content: "Participate actively in the future of the AizaHcare ecosystem. Token holders possess voting rights on key protocol upgrades, the integration of new medical centers, and the strategic direction of our MAIDA AI compute infrastructure."
}];
export default function TheUtilityEngine() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}